import { render, staticRenderFns } from "./ManageOTK.vue?vue&type=template&id=396b3258&scoped=true"
import script from "./ManageOTK.vue?vue&type=script&lang=js"
export * from "./ManageOTK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396b3258",
  null
  
)

export default component.exports